import { render, staticRenderFns } from "./SitesChangeRequestsTable.vue?vue&type=template&id=4ae6996e&scoped=true&lang=pug"
import script from "./SitesChangeRequestsTable.vue?vue&type=script&lang=js"
export * from "./SitesChangeRequestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae6996e",
  null
  
)

export default component.exports